/**
 * IMPORTS
 */

import type { NavigateFunction } from "react-router-dom";

// typings
import type { ICliente } from "@/store-zustand/manage-client/index.d";

type IAbrirEdicaoClienteProps = {
  router: NavigateFunction;
  setClienteEditar: (clienteEditar: ICliente | null) => void;
  cliente: ICliente;
};

/**
 * Seleciona o cliente para edição e navega para a tela de edição dos dados dele.
 * Usado pela ação "Editar" e pelo clique na linha da tabela de clientes.
 */
function abrirEdicaoCliente({ router, setClienteEditar, cliente }: IAbrirEdicaoClienteProps) {
  setClienteEditar(cliente);
  router("/edit-client-data", {
    state: {
      cliente: {
        id: cliente?.id,
      },
    },
  });
}

/**
 * EXPORTS
 */
export { abrirEdicaoCliente };
